import type * as SchemaTypes from '../types';

import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type CurrentUserDataFragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id' | 'displayName' | 'isAuthenticatorEnabled' | 'isPasswordExpired' | 'email' | 'passwordExpiresAt' | 'alias' | 'permissions'>
  & { mobile: (
    { __typename: 'Phone' }
    & Pick<SchemaTypes.Phone, 'prefix' | 'value'>
  ), profileImage?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )> }
);

export const CurrentUserDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUserData on User {
  id
  displayName
  isAuthenticatorEnabled
  isPasswordExpired
  email
  passwordExpiresAt
  mobile {
    prefix
    value
  }
  profileImage {
    ...UploadFileWithPreviewFormData
  }
  alias
  permissions
}
    `;